import { Alert, Flex } from 'antd';

const NoComponent = () => {
  return (
    <Flex gap="middle" vertical>
      <h2>Waring!</h2>
      <Alert message="Add a component" type="warning" />
    </Flex>
  );
};

export default NoComponent;
